module.exports = __webpack_public_path__ + "c3de23017bcb95715e6eb11dd6a10fc5.woff";